/* Dashboard "Operations overview" — embeds the Task Report KPIs (summary only) on the
   dashboard. Opens by default on Harvesting + current month + all blocks; reuses the
   /api/report/task/data endpoint. Full detail (table/charts) lives on the Report page. */
if (document.getElementById('dash-kpis')) {
  (function () {
    // A KPI's rendered value is numerically zero (ignores '—', units, RM, commas).
    const isZeroKpi = k => {
      const t = String(k.value || '').replace(/<[^>]*>/g, '').replace(/,/g, '').trim();
      if (t === '' || t === '—') return false;
      const num = parseFloat(t.replace(/[^0-9.\-]/g, ''));
      return !isNaN(num) && num === 0;
    };

    function render(p) {
      const kpis = (p && p.kpis) || [];
      // first card orange · a zero value red · everything else green (same as the report)
      document.getElementById('dash-kpis').innerHTML = kpis.map((k, i) => {
        const tone = i === 0 ? 'kpi-area' : (isZeroKpi(k) ? 'kpi-zero' : '');
        return `<div class="dk-card ${tone}"><div>${k.label}</div>` +
          `<div>${k.value}</div>` +
          `<div>${k.sub || ''}</div>` +
          (k.pct != null ? `<div class="bar"><span style="width:${k.pct}%"></span></div>` : '') +
          `</div>`;
      }).join('');
      const note = document.getElementById('dash-kpi-note');
      if (note) {
        const op = (p && p.operation && p.operation.name) || '';
        note.innerHTML = '<i class="bi bi-info-circle"></i> ' + op + ' · ' +
          (p.from_date || '…') + ' → ' + (p.to_date || '…') + ' · ' + (p.log_count || 0) + ' daily entries';
      }
    }

    // ── overview charts (Harvesting → FFB; other ops → cost/area) ─────────────────
    const charts = {};
    const clearCharts = () => { Object.values(charts).forEach(c => c.destroy()); for (const k in charts) delete charts[k]; };
    function drawBar(id, labels, data, yText, color) {
      if (charts[id]) charts[id].destroy();
      const el = document.getElementById(id);
      if (!el || !window.Chart) return;
      charts[id] = new Chart(el, {
        type: 'bar',
        data: { labels: labels, datasets: [{ label: yText, data: data, backgroundColor: color, borderRadius: 4 }] },
        options: { plugins: { legend: { display: false } }, scales: { y: { beginAtZero: true, title: { display: true, text: yText } } } }
      });
    }
    // top-N blocks by a numeric getter
    function blocksBar(id, blocks, getter, yText, color) {
      const rows = (blocks || []).map(b => ({ name: b.name, v: +getter(b) || 0 }))
        .filter(r => r.v > 0).sort((a, b) => b.v - a.v).slice(0, 10);
      drawBar(id, rows.map(r => r.name), rows.map(r => r.v), yText, color);
    }
    function loadTopHarvesters(id, month, blk) {
      const data = { month: month };
      if (blk) data.block_ids = blk;
      $.ajax({ url: '/api/report/worker/data', method: 'GET', data: data }).done(p => {
        const rows = ((p && p.workers) || []).map(w => ({ name: (w.name || '—').split(' ')[0], wt: +((w.metrics || {}).total_weight) || 0 }))
          .filter(r => r.wt > 0).sort((a, b) => b.wt - a.wt).slice(0, 10);
        drawBar(id, rows.map(r => r.name), rows.map(r => r.wt), 'FFB (MT)', '#3b82f6');
      });
    }

    function load() {
      const tid = $('#dash-op').val();
      if (!tid) return;
      const month = $('#dash-month').val() || '';
      const blk = $('#dash-block').val();
      const data = { template_id: tid, month: month };
      if (blk) data.block_ids = blk;
      $('#dash-kpis').html('<div class="col-span-full text-slate-400 text-sm py-4">Loading…</div>');
      $.ajax({ url: '/api/report/task/data', method: 'GET', data: data })
        .done(p => {
          render(p);
          $('#dash-charts').removeClass('hidden');
          clearCharts();
          if ((p.operation && p.operation.name) === 'Harvesting') {
            $('#dash-ct-a').text('Top blocks by FFB (MT)');
            $('#dash-ct-b').text('Top harvesters by FFB (MT)');
            blocksBar('dash-ch-a', p.blocks, b => (b.metrics || {}).total_weight, 'FFB (MT)', '#10b981');
            loadTopHarvesters('dash-ch-b', month, blk);
          } else {
            // other operations: cost + area covered, by block
            $('#dash-ct-a').text('Total cost by block (RM)');
            $('#dash-ct-b').text('Area covered by block (ha)');
            blocksBar('dash-ch-a', p.blocks, b => (b.costs || {}).total, 'Total cost (RM)', '#f59e0b');
            blocksBar('dash-ch-b', p.blocks, b => b.area_covered, 'Area covered (ha)', '#06b6d4');
          }
        })
        .fail(xhr => {
          $('#dash-kpis').html('<div class="col-span-full text-red-500 text-sm py-4">Failed to load overview' +
            (xhr.responseJSON && xhr.responseJSON.error ? ': ' + xhr.responseJSON.error : '') + '.</div>');
          $('#dash-charts').addClass('hidden');
        });
    }

    $(function () {
      const now = new Date(), pad = n => String(n).padStart(2, '0');
      $('#dash-month').val(`${now.getFullYear()}-${pad(now.getMonth() + 1)}`);
      $('#dash-apply').on('click', load);
      // Auto-render on dashboard open: Harvesting (default-selected) · current month · all blocks.
      load();
    });
  })();
}
